import { Skeleton } from '@/components/ui/skeleton';
import { EventCardSkeleton } from './EventCardSkeleton';

/**
 * Skeleton loading state for the events list.
 * Shows placeholder date headers and event cards.
 */
export function EventsListSkeleton() {
  return (
    <div className="space-y-6">
      {[1, 2].map((group) => (
        <div key={group}>
          <Skeleton className="h-6 w-32 mb-3" />
          <div className="space-y-3">
            <EventCardSkeleton />
            <EventCardSkeleton />
          </div>
        </div>
      ))}
    </div>
  );
}

